import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

class ConstructionSiteLot extends SmartModel {

	static STATUS_WAITING = 1;
	static STATUS_CSC_CREATED = 2;

	constructor (data) {
		super();

		this.applicatorTeamId = "";
        this.area = "";
        this.cca = "";
        this.cscGuid = "";
        this.expetedAmount = 0;
		this.multipleDates = [];
        this.note = "";
        this.name = "";
        this.status = 1;
		this.timeSpanEnd = "0000-00-00 00:00:00";
		this.timeSpanStart = "0000-00-00 00:00:00";

		this.__ccaLabel = "";
		this.__multipleDates = false;
		this.__hasMultipleDates = [];
		this.__lotIndex = 0;
		this.__status_waiting = false;
		this.__timeSpanEnd = "";
		this.__timeSpanStart = "";

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = this.__export();

		exportData.timeSpanEnd = moment.utc(this.timeSpanEnd).format(Shark.get("dateISODateTimeFormat"));
		exportData.timeSpanStart = moment.utc(this.timeSpanStart).format(Shark.get("dateISODateTimeFormat"));

		return exportData;
	}
	
	on__timeSpanEndChanged () {
		this.timeSpanEnd = moment(this.__timeSpanEnd);
	}

	on__timeSpanStartChanged () {
		this.timeSpanStart = moment(this.__timeSpanStart);
	}

	import (data, options) {
		this.__import(data, options);

        this.importNumberField("status", data.status);
		if (this.importDateField("timeSpanEnd", data.timeSpanEnd)) {
			this.__timeSpanEnd = this.timeSpanEnd.format("YYYY-MM-DD");
		}
		if (this.importDateField("timeSpanStart", data.timeSpanStart)) {
			this.__timeSpanStart = this.timeSpanStart.format("YYYY-MM-DD");
		}

		this.parseCCA();
		this.parseMultipleDates();
		this.parseStatus();
	}

	parseCCA () {
		if (this.cca && this.cca !== "") {
			this.__ccaLabel = "<strong>" + this.cca + "</strong>";
			this.__ccaCSSClass = "cca-status-success";
		}
		else {
			this.__ccaLabel = "Non impostata";
			this.__ccaCSSClass = "cca-status-warning";
		}
	}

	parseMultipleDates () {
		if (this.multipleDates) {
			this.__multipleDates = [];

			this.multipleDates.forEach(item => {
				//Dave: questa cosa è da spostare altrove
				const applicatorTeamList = Shark.get("applicatorTeamList");
				const cloned = Object.assign({}, item);

				if (applicatorTeamList && applicatorTeamList.length > 0) {
					const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", item.applicatorTeamId);
		
					if (currApplicatorTeam) {
						cloned.__applicatorTeamName = currApplicatorTeam.name;
					}
				}

				if (typeof item.constructionEndDateTime.isValid === "undefined") {
					item.constructionEndDateTime = moment(item.constructionEndDateTime);
					item.constructionStartDateTime = moment(item.constructionStartDateTime);
				}
				
				cloned.__timeSpanEndLabel = item.constructionEndDateTime.format(Shark.get("dateHumanFormat"));
				cloned.__timeSpanStartLabel = item.constructionStartDateTime.format(Shark.get("dateHumanFormat"));
		
				this.__multipleDates.push(cloned);
			});

			this.__hasMultipleDates = this.__multipleDates.length > 1;
		}
	}

	parseStatus () {
		this.__status_waiting = this.status === ConstructionSiteLot.STATUS_WAITING;
		this.__status_cscCreated = this.status === ConstructionSiteLot.STATUS_CSC_CREATED;
	}
}

Shark.registerModel("ConstructionSiteLot", ConstructionSiteLot);

export default ConstructionSiteLot;
